import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { usePrevious } from 'client/site-modules/shared/hooks/use-previous';

const PhotoflipperModalLoader = lazyLoad({
  loader: () => import(/* webpackChunkName: "photoflipper-core-modal" */ './photoflipper-modal'),
  componentName: 'PhotoflipperModal',
});

export function PhotoflipperModalAsync({ isOpen = false, ...restProps }) {
  const [isLoaded, setLoaded] = useState(() => !!isOpen);
  const prevIsOpen = usePrevious(isOpen);

  if (prevIsOpen !== isOpen) {
    if (isOpen && !isLoaded) setLoaded(true);
  }

  return isLoaded ? <PhotoflipperModalLoader {...restProps} isOpen={isOpen} /> : null;
}

PhotoflipperModalAsync.propTypes = {
  isOpen: PropTypes.bool,
};
